// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MetricCard.css - World-Class Admin Dashboard Metric Cards Styling */

/* CSS Variables for consistency */
:root {
  --card-min-height: 180px;
  --card-padding: 24px;
  --card-gap: 20px;
  --card-border-radius: 12px;
  --card-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  --card-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  --card-shadow-hover: 0 10px 25px rgba(0, 0, 0, 0.1);
}

/* Grid Container - Makes all cards same size */
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--card-gap);
  margin-bottom: 2rem;
  max-width: 100%;
  width: 100%;
}

/* Force all cards to have same height */
.metrics-grid > * {
  min-height: var(--card-min-height);
  height: 100%;
}

/* Responsive Grid */
@media (max-width: 1199px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (max-width: 767px) {
  .metrics-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  :root {
    --card-min-height: 160px;
    --card-padding: 20px;
  }
}

/* Metric Card Wrapper - Applied to ALL metric cards for consistency */
.metric-card-wrapper {
  /* Ensure consistent sizing */
  min-height: var(--card-min-height) !important;
  height: 100% !important;
  
  /* Visual consistency - Override Material-UI styles */
  background: var(--card-bg, #ffffff) !important;
  border: 1px solid var(--card-border, #e5e7eb) !important;
  border-radius: var(--card-border-radius) !important;
  box-shadow: var(--card-shadow) !important;
  transition: var(--card-transition) !important;
  
  /* Flexbox for content organization */
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  
  /* Handle overflow */
  overflow: hidden !important;
  position: relative !important;
}

/* Hover effect for all cards */
.metric-card-wrapper:hover {
  transform: translateY(-4px) !important;
  box-shadow: var(--card-shadow-hover) !important;
  border-color: transparent !important;
}

/* Override Material-UI CardContent padding for consistency */
.metric-card-wrapper .MuiCardContent-root {
  padding: var(--card-padding) !important;
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  height: 100% !important;
}

/* Ensure content doesn't overflow */
.metric-card-wrapper > * {
  flex-shrink: 0;
}

/* Fix text overflow issues - Target Material-UI Typography components */
.metric-card-wrapper .MuiTypography-body2 {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: var(--text-secondary, #6b7280) !important;
  margin: 0 0 8px 0 !important;
  letter-spacing: 0.025em !important;
  text-transform: uppercase !important;
  
  /* Prevent overflow */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

/* Style the main metric values - Target Material-UI h4 Typography */
.metric-card-wrapper .MuiTypography-h4 {
  font-size: 32px !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
  margin: 4px 0 !important;
  
  /* Prevent overflow */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

/* Ensure icons are consistent size */
.metric-card-wrapper .MuiSvgIcon-root {
  width: 24px !important;
  height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
}

/* Large icons in the top right */
.metric-card-wrapper .MuiSvgIcon-fontSizeLarge {
  width: 48px !important;
  height: 48px !important;
}

/* Fix any internal spacing issues */
.metric-card-wrapper .MuiCardContent-root > div {
  width: 100% !important;
}

/* Ensure trend indicators align properly */
.metric-card-wrapper .MuiBox-root {
  display: flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
}

/* Style trend icons */
.metric-card-wrapper .MuiSvgIcon-fontSizeSmall {
  width: 16px !important;
  height: 16px !important;
}

/* Loading state styling */
.metric-card-wrapper.loading {
  pointer-events: none !important;
  background: var(--skeleton-bg, #f3f4f6) !important;
}

/* Animation for value updates */
.metric-card-wrapper .updated {
  animation: metricPulse 0.6s ease !important;
}

@keyframes metricPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

/* Ensure consistent card heights across the row using CSS Grid */
@supports (display: grid) {
  .metrics-grid {
    grid-auto-rows: 1fr !important;
  }
}

/* Fix specific alignment issues without changing functionality */
.metric-card-wrapper .MuiCardContent-root > :first-child {
  margin-top: 0 !important;
}

.metric-card-wrapper .MuiCardContent-root > :last-child {
  margin-bottom: 0 !important;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .metric-card-wrapper {
    --card-bg: #1f2937 !important;
    --card-border: #374151 !important;
    --text-primary: #f9fafb !important;
    --text-secondary: #d1d5db !important;
  }
}

/* Ensure Grid items maintain consistent heights */
.metrics-grid .MuiGrid-item {
  display: flex !important;
  flex-direction: column !important;
}

.metrics-grid .MuiGrid-item > * {
  flex: 1 !important;
  height: 100% !important;
}

/* Typography adjustments for better hierarchy */
.metric-card-wrapper .MuiTypography-h6 {
  font-size: 18px !important;
  font-weight: 600 !important;
  margin-bottom: 16px !important;
  color: var(--text-primary, #1f2937) !important;
}

/* Subtitle text styling */
.metric-card-wrapper .MuiTypography-body2:not(:first-child) {
  text-transform: none !important;
  font-weight: 400 !important;
  color: var(--text-secondary, #6b7280) !important;
  margin-top: auto !important;
}

/* Skeleton loading states */
.metric-card-wrapper .MuiSkeleton-root {
  background: var(--skeleton-bg, #f3f4f6) !important;
  border-radius: 4px !important;
}

/* Ensure proper spacing in card header */
.metric-card-wrapper .MuiBox-root:first-child {
  margin-bottom: 8px !important;
}

/* Handle long text in subtitles */
.metric-card-wrapper .MuiTypography-body2:last-child {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 1.4 !important;
}

/* Responsive text sizing */
@media (max-width: 767px) {
  .metric-card-wrapper .MuiTypography-h4 {
    font-size: 28px !important;
  }
  
  .metric-card-wrapper .MuiTypography-body2 {
    font-size: 12px !important;
  }
  
  .metric-card-wrapper .MuiSvgIcon-fontSizeLarge {
    width: 40px !important;
    height: 40px !important;
  }
}

/* Enhanced accessibility */
.metric-card-wrapper:focus-visible {
  outline: 2px solid var(--focus-color, #2563eb) !important;
  outline-offset: 2px !important;
}

/* Print styles */
@media print {
  .metric-card-wrapper {
    box-shadow: none !important;
    border: 1px solid #ccc !important;
    break-inside: avoid !important;
  }
  
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/MetricCard.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE,kCAAkC;AAClC;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,wDAAwD;EACxD,2CAA2C;EAC3C,mDAAmD;AACrD;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;AACF;;AAEA,sEAAsE;AACtE;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,uBAAuB;;EAEvB,qDAAqD;EACrD,8CAA8C;EAC9C,wDAAwD;EACxD,mDAAmD;EACnD,yCAAyC;EACzC,6CAA6C;;EAE7C,qCAAqC;EACrC,wBAAwB;EACxB,iCAAiC;EACjC,yCAAyC;;EAEzC,oBAAoB;EACpB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,sCAAsC;EACtC,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA,6DAA6D;AAC7D;EACE,uCAAuC;EACvC,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gDAAgD;EAChD,4BAA4B;EAC5B,kCAAkC;EAClC,oCAAoC;;EAEpC,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,oEAAoE;AACpE;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;;EAExB,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA,gCAAgC;AAChC;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA,iEAAiE;AACjE;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,iEAAiE;AACjE;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,6BAA6B;IAC7B,iCAAiC;IACjC,kCAAkC;IAClC,oCAAoC;EACtC;AACF;;AAEA,kDAAkD;AAClD;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,gDAAgD;AAChD;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,kDAAkD;EAClD,6BAA6B;AAC/B;;AAEA,yCAAyC;AACzC;EACE,6BAA6B;AAC/B;;AAEA,kCAAkC;AAClC;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE,yDAAyD;EACzD,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE;IACE,2BAA2B;IAC3B,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,gDAAgD;IAChD,oBAAoB;EACtB;AACF","sourcesContent":["/* MetricCard.css - World-Class Admin Dashboard Metric Cards Styling */\n\n/* CSS Variables for consistency */\n:root {\n  --card-min-height: 180px;\n  --card-padding: 24px;\n  --card-gap: 20px;\n  --card-border-radius: 12px;\n  --card-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  --card-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  --card-shadow-hover: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n/* Grid Container - Makes all cards same size */\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--card-gap);\n  margin-bottom: 2rem;\n  max-width: 100%;\n  width: 100%;\n}\n\n/* Force all cards to have same height */\n.metrics-grid > * {\n  min-height: var(--card-min-height);\n  height: 100%;\n}\n\n/* Responsive Grid */\n@media (max-width: 1199px) {\n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n}\n\n@media (max-width: 767px) {\n  .metrics-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  :root {\n    --card-min-height: 160px;\n    --card-padding: 20px;\n  }\n}\n\n/* Metric Card Wrapper - Applied to ALL metric cards for consistency */\n.metric-card-wrapper {\n  /* Ensure consistent sizing */\n  min-height: var(--card-min-height) !important;\n  height: 100% !important;\n  \n  /* Visual consistency - Override Material-UI styles */\n  background: var(--card-bg, #ffffff) !important;\n  border: 1px solid var(--card-border, #e5e7eb) !important;\n  border-radius: var(--card-border-radius) !important;\n  box-shadow: var(--card-shadow) !important;\n  transition: var(--card-transition) !important;\n  \n  /* Flexbox for content organization */\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: space-between !important;\n  \n  /* Handle overflow */\n  overflow: hidden !important;\n  position: relative !important;\n}\n\n/* Hover effect for all cards */\n.metric-card-wrapper:hover {\n  transform: translateY(-4px) !important;\n  box-shadow: var(--card-shadow-hover) !important;\n  border-color: transparent !important;\n}\n\n/* Override Material-UI CardContent padding for consistency */\n.metric-card-wrapper .MuiCardContent-root {\n  padding: var(--card-padding) !important;\n  flex: 1 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: space-between !important;\n  height: 100% !important;\n}\n\n/* Ensure content doesn't overflow */\n.metric-card-wrapper > * {\n  flex-shrink: 0;\n}\n\n/* Fix text overflow issues - Target Material-UI Typography components */\n.metric-card-wrapper .MuiTypography-body2 {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: var(--text-secondary, #6b7280) !important;\n  margin: 0 0 8px 0 !important;\n  letter-spacing: 0.025em !important;\n  text-transform: uppercase !important;\n  \n  /* Prevent overflow */\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n/* Style the main metric values - Target Material-UI h4 Typography */\n.metric-card-wrapper .MuiTypography-h4 {\n  font-size: 32px !important;\n  font-weight: 700 !important;\n  line-height: 1.2 !important;\n  margin: 4px 0 !important;\n  \n  /* Prevent overflow */\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n/* Ensure icons are consistent size */\n.metric-card-wrapper .MuiSvgIcon-root {\n  width: 24px !important;\n  height: 24px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-shrink: 0 !important;\n}\n\n/* Large icons in the top right */\n.metric-card-wrapper .MuiSvgIcon-fontSizeLarge {\n  width: 48px !important;\n  height: 48px !important;\n}\n\n/* Fix any internal spacing issues */\n.metric-card-wrapper .MuiCardContent-root > div {\n  width: 100% !important;\n}\n\n/* Ensure trend indicators align properly */\n.metric-card-wrapper .MuiBox-root {\n  display: flex !important;\n  align-items: center !important;\n  gap: 0.5rem !important;\n}\n\n/* Style trend icons */\n.metric-card-wrapper .MuiSvgIcon-fontSizeSmall {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n/* Loading state styling */\n.metric-card-wrapper.loading {\n  pointer-events: none !important;\n  background: var(--skeleton-bg, #f3f4f6) !important;\n}\n\n/* Animation for value updates */\n.metric-card-wrapper .updated {\n  animation: metricPulse 0.6s ease !important;\n}\n\n@keyframes metricPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n}\n\n/* Ensure consistent card heights across the row using CSS Grid */\n@supports (display: grid) {\n  .metrics-grid {\n    grid-auto-rows: 1fr !important;\n  }\n}\n\n/* Fix specific alignment issues without changing functionality */\n.metric-card-wrapper .MuiCardContent-root > :first-child {\n  margin-top: 0 !important;\n}\n\n.metric-card-wrapper .MuiCardContent-root > :last-child {\n  margin-bottom: 0 !important;\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .metric-card-wrapper {\n    --card-bg: #1f2937 !important;\n    --card-border: #374151 !important;\n    --text-primary: #f9fafb !important;\n    --text-secondary: #d1d5db !important;\n  }\n}\n\n/* Ensure Grid items maintain consistent heights */\n.metrics-grid .MuiGrid-item {\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.metrics-grid .MuiGrid-item > * {\n  flex: 1 !important;\n  height: 100% !important;\n}\n\n/* Typography adjustments for better hierarchy */\n.metric-card-wrapper .MuiTypography-h6 {\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  margin-bottom: 16px !important;\n  color: var(--text-primary, #1f2937) !important;\n}\n\n/* Subtitle text styling */\n.metric-card-wrapper .MuiTypography-body2:not(:first-child) {\n  text-transform: none !important;\n  font-weight: 400 !important;\n  color: var(--text-secondary, #6b7280) !important;\n  margin-top: auto !important;\n}\n\n/* Skeleton loading states */\n.metric-card-wrapper .MuiSkeleton-root {\n  background: var(--skeleton-bg, #f3f4f6) !important;\n  border-radius: 4px !important;\n}\n\n/* Ensure proper spacing in card header */\n.metric-card-wrapper .MuiBox-root:first-child {\n  margin-bottom: 8px !important;\n}\n\n/* Handle long text in subtitles */\n.metric-card-wrapper .MuiTypography-body2:last-child {\n  white-space: normal !important;\n  overflow: visible !important;\n  text-overflow: unset !important;\n  line-height: 1.4 !important;\n}\n\n/* Responsive text sizing */\n@media (max-width: 767px) {\n  .metric-card-wrapper .MuiTypography-h4 {\n    font-size: 28px !important;\n  }\n  \n  .metric-card-wrapper .MuiTypography-body2 {\n    font-size: 12px !important;\n  }\n  \n  .metric-card-wrapper .MuiSvgIcon-fontSizeLarge {\n    width: 40px !important;\n    height: 40px !important;\n  }\n}\n\n/* Enhanced accessibility */\n.metric-card-wrapper:focus-visible {\n  outline: 2px solid var(--focus-color, #2563eb) !important;\n  outline-offset: 2px !important;\n}\n\n/* Print styles */\n@media print {\n  .metric-card-wrapper {\n    box-shadow: none !important;\n    border: 1px solid #ccc !important;\n    break-inside: avoid !important;\n  }\n  \n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 10px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
